import React, { useState } from "react";
import "./Turntable_spin_wheel.css";
import { useDispatch } from "react-redux";
import { GetAllTurntableHistory, GetTurntableDash, HitTurntableSpin } from "../../../features/spin/Slice";
import Successfull_strip_modal from "../../Common/Common_Component/Common_Modal/Successfull_strip_modal/Successfull_strip_modal";
import { formatAmount } from "../../../utils/common";

function Turntable_spin_wheel() {

  const dispatch = useDispatch()

  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const segments = [
    { value: 20, angle: 45 },
    { value: 50, angle: 0 },
    { value: 100, angle: 315 },
    { value: 250, angle: 270 },
    { value: 500, angle: 225 },
    { value: 1000, angle: 180 },
    { value: 10000, angle: 135 },
    { value: 50000, angle: 90 },
  ];

  const getAngleFromReward = (reward) => {
    const matches = segments.filter(s => s.value === reward);

    if (!matches.length) return 0;

    const randomSegment =
      matches[Math.floor(Math.random() * matches.length)];

    return randomSegment.angle;
  };
  const [rotation, setRotation] = useState(67);
  const [isSpinning, setIsSpinning] = useState(false);

  // const handleSpin = () => {
  //   if (isSpinning) return;

  //   const extraSpin = 3600 + Math.floor(Math.random() * 360); // 10+ rounds
  //   const newRotation = rotation + extraSpin;

  //   setRotation(newRotation);
  //   setIsSpinning(true);

  //   setTimeout(() => {
  //     setIsSpinning(false);
  //   }, 4000);
  // };


  const handleSpin = async () => {
    if (isSpinning) return;

    setIsSpinning(true);

    try {
      const res = await dispatch(HitTurntableSpin());

      let reward = 20;
      if (res.meta?.requestStatus === "fulfilled") {

        reward = res?.payload?.data?.reward

        const targetAngle = await getAngleFromReward(reward);

        const extraSpins = 360 * 10;

        const currentAngle = rotation % 360;

        const delta = (360 + targetAngle - currentAngle) % 360;

        const finalRotation = rotation + extraSpins + delta;

        setRotation(finalRotation);

        const wait = (ms) => new Promise(res => setTimeout(res, ms));

        await wait(4000);

        setIsSpinning(false);
        setModalShow(true);
        setModalMessage(`You Won ${formatAmount(reward)}`);
        await dispatch(GetTurntableDash())
        await dispatch(GetAllTurntableHistory())
        await wait(2000);

        setModalShow(false);
        setModalMessage("");



      } else if (res.meta?.requestStatus === "rejected") {
        setIsSpinning(false);
        setModalShow(true);
        setModalMessage(res.payload?.errors);
        setTimeout(() => {
          setModalShow(false);
          setModalMessage("");
        }, 2000);

      }

    } catch (err) {
      setIsSpinning(false);
      console.log("Turntable_spin_wheel :", err);

    }
  };



  return (
    <section className="Turntable_spin_wheel">
      <div className="wheel_container">

        {/* Wheel */}
        <div
          className="wheel"
          style={{ transform: `rotate(${rotation}deg)` }}
        >
          <img
            src="/assets/images/turntable_spin_wheel/wheel.png"
            alt="wheel"
          />
        </div>

        {/* GO Button */}
        <div className="go_btn" onClick={handleSpin}>
          <img src="/assets/images/turntable_spin_wheel/button.png" alt="go" />
        </div>

      </div>

      <Successfull_strip_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textMsg={modalMessage}
      />
    </section>
  );
}

export default Turntable_spin_wheel;